// DEPENDENCIES ---------------------------------------------------------------- //

import { MapLocationSelectorMarkerProps } from './types';
import { LocationPinBubble, LocationPinMarker } from '@components/Maps';

// COMPONENT ---------------------------------------------------------------- //

const MapLocationSelectorMarker = ({
  mapId,
  marker,
  selected,
  onMarkerClick,
  showBubble = true,
  isLaneComplete = false,
  hintText,
  deselectable,
  bubbleTitle,
}: MapLocationSelectorMarkerProps) => {
  const pinSize = isLaneComplete ? 48 : 36;
  const iconSize = isLaneComplete ? 28 : 20;
  const pinZIndex = selected ? 10 : 1;

  const resolvedBubbleTitle =
    bubbleTitle ??
    (marker.id === 'pickup'
      ? 'Pickup Location'
      : marker.id === 'delivery'
        ? 'Delivery Location'
        : 'Selectable Location');

  return (
    <LocationPinMarker
      mapId={mapId}
      markerId={marker.id}
      position={{ lat: marker.position.lat, lng: marker.position.lng }}
      size={pinSize}
      iconSize={iconSize}
      hintText={hintText}
      hoverBrighter={deselectable}
      zIndex={pinZIndex}
      onClick={() => onMarkerClick?.(marker)}
    >
      {showBubble ? (
        <LocationPinBubble
          markerId={marker.id}
          title={resolvedBubbleTitle}
          name={marker.name || 'Unknown Location'}
          address={marker.address || 'Unknown Address'}
          position={marker.position}
          favorited={marker.favorite}
          maxWidth={300}
          pointerEvents='none'
        />
      ) : null}
    </LocationPinMarker>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default MapLocationSelectorMarker;
